<div id="container">
  <div id="inner_container">
    <ng-content></ng-content>
  </div>
  <app-footer></app-footer>
</div>
